import axios from '@/axios'
import * as types from '../mutation-types'
import { accountConfig, itemConfig, configs, type } from '@/helpers/enums';

export default {
	namespaced: true,

	state: {
		itemsConfigs: {
			cardamomRootId: null,
			rawCardamomId: null,
			crushId: null,
			seedsId: null,
		},
		accountsConfigs: {
			ownersRootId: null,
			providersRootId: null,
			customersRootId: null,
			detachmentId: null,
		},
		configsTrees: {
			owners: [],
			providers: [],
			customers: [],
		}
	},

	actions: {
		fetchAll({ commit }) {
			return Promise.all([
				axios.get('/accounts/accountsConfig').then(data => {
					commit(types.STORE_ACCOUNTS_CONFIGS, data);
					return null;
				}),
				axios.get('/items/itemConfigs').then(data => {
					commit(types.STORE_ITEMS_CONFIGS, data);
					return null;
				}),
			])
		},

		async fetchConfigAccounts({ state, commit }) {
			const accountsConfigs = state.accountsConfigs;
			const accountsTrees = {}
			// owners trees
			if (accountsConfigs.ownersRootId) {
				await axios.get(`/accounts/descendants/${accountsConfigs.ownersRootId}`).then(data => {
					const storeData =
						data.filter(c =>
							![accountsConfigs.ownersRootId, accountsConfigs.detachmentId].includes(c.id) &&
							c.accountType === type.sub
						);
					accountsTrees.owners = storeData;
					return storeData;
				})
			}
			
			// providers trees
			if (accountsConfigs.providersRootId) {
				await axios.get(`/accounts/descendants/${accountsConfigs.providersRootId}`).then(data => {
					const storeData =
						data.filter(c =>
							![accountsConfigs.providersRootId, accountsConfigs.detachmentId].includes(c.id) &&
							c.accountType === type.sub
						);
					accountsTrees.providers = storeData;
					return storeData;
				})
			}
			
			// customers trees
			if (accountsConfigs.customersRootId) {
				await axios.get(`/accounts/descendants/${accountsConfigs.customersRootId}`).then(data => {
					const storeData =
						data.filter(c =>
							![accountsConfigs.customersRootId, accountsConfigs.detachmentId].includes(c.id) &&
							c.accountType === type.sub
						);
					accountsTrees.customers = storeData;
					return storeData;
				})
			}

			commit(types.STORE_ACCOUNTS_TREES, accountsTrees);
			return accountsTrees;
		},

		update({ commit }, { configType, id }) {
			let config;
			// accounts configs
			if ([configs.owners, configs.providers, configs.customers, configs.detachment].includes(configType)) {
				if (configType === configs.owners) config = accountConfig.owners;
				else if (configType === configs.providers) config = accountConfig.providers;
				else if (configType === configs.customers) config = accountConfig.customers;
				else if (configType === configs.detachment) config = accountConfig.detachment;
				
				return axios.post('/accounts/accountConfig', { configType: config, accountId: id });
			// items configs
			} else if ([configs.rawCardamom, configs.cardamomRoot, configs.crush, configs.seeds].includes(configType)) {
				if (configType === configs.rawCardamom) config = itemConfig.rawCardamom;
				else if (configType === configs.cardamomRoot) config = itemConfig.cardamomRoot;
				else if (configType === configs.crush) config = itemConfig.crush;
				else if (configType === configs.seeds) config = itemConfig.seeds;

				return axios.post('/items/itemConfig', { configType: config, itemId: id });
			}
		},
		reset({ commit }) {
			commit(types.RESET);
		}
	},

	mutations: {
		[types.STORE_ACCOUNTS_CONFIGS](state, configs) {
			state.accountsConfigs.ownersRootId =
				configs.find(c => c.configType === accountConfig.owners)?.accountId ?? null;
			state.accountsConfigs.providersRootId =
				configs.find(c => c.configType === accountConfig.providers)?.accountId ?? null;
			state.accountsConfigs.customersRootId =
				configs.find(c => c.configType === accountConfig.customers)?.accountId ?? null;
			state.accountsConfigs.detachmentId =
				configs.find(c => c.configType === accountConfig.detachment)?.accountId ?? null;
		},
		[types.STORE_ITEMS_CONFIGS](state, configs) {
			state.itemsConfigs.cardamomRootId =
				configs.find(c => c.configType === itemConfig.cardamomRoot)?.itemId ?? null;
			state.itemsConfigs.rawCardamomId =
				configs.find(c => c.configType === itemConfig.rawCardamom)?.itemId ?? null;
			state.itemsConfigs.crushId =
				configs.find(c => c.configType === itemConfig.crush)?.itemId ?? null;
			state.itemsConfigs.seedsId =
				configs.find(c => c.configType === itemConfig.seeds)?.itemId ?? null;
		},
		[types.STORE_ACCOUNTS_TREES](state, accountsTrees) {
			state.configsTrees.owners = accountsTrees.owners || [];
			state.configsTrees.providers = accountsTrees.providers || [];
			state.configsTrees.customers = accountsTrees.customers || [];
		},
		[types.RESET](state) {
			state.itemsConfigs.cardamomRootId = null;
			state.itemsConfigs.rawCardamomId = null;
			
			state.accountsConfigs.ownersRootId = null;
			state.accountsConfigs.providersRootId = null;
			state.accountsConfigs.customersRootId = null;
			
			state.configsTrees.owners = [];
			state.configsTrees.providers = [];
			state.configsTrees.customers = [];
		}
	}
}